<template>
  <div>
    <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="LineChart" @ready="onChartReady" />
    <div id="chart-container" class="row">
      <div id="cp-by-functional-need-chart" class="functional-needs col-lg-12">
        <div id="cp-by-functional-need-title-and-chart" class="title-and-chart">
          <div class="title-and-chart-left">
            <div class="chart-title-container" v-show="this.$parent.getDisplayView() && getDisplayView()">
              <h4 class="text-primary">
                Needs Profile
                <smart-center-link page="Profiles" location="Expectations" />
              </h4>
              <div class="chart-title functional">
                <div class="chart-sub-title">
                  <span class="customer">Importance</span> vs.
                  <span>Satisfaction</span>
                </div>
              </div>
            </div>
            <chart-legend
              :include-number-of-responses="true"
              :class="getLegendClass('pt-4 pb-1')"
              height="auto"
              :direction="'vertical'"
              :width="'auto'"
              location="Profile By Need (Functional)"
              :elements="$parent.legendElements"
              :container-id="'cp-by-functional-need-chart'"
              :show-number-of-responses="this.$parent.chartDisplayOptions.showNumberOfResponses"
              @redraw="showOrHideElementsForNeedsProfile"
            >
            </chart-legend>
          </div>
          <div class="buttons-and-chart">
            <chart-buttons
              :display="this.$parent.getDisplayView() && getDisplayView()"
              :tooltip-configuration="snapChartTooltipConfig"
              :snap-container-id="'cp-by-functional-need-title-and-chart'"
              :container-id="'cp-by-functional-need-chart'"
              :power-point-container-id="'needs_profile_chart'"
              :report-page-type-name="'Chart - Needs Profile'"
              :insight-modal-id="'functional-needs-chart'"
              :text-direction="this.$parent.chartDisplayOptions.functional.textDirection"
            >
            </chart-buttons>
            <div id="needs_profile_chart" class="d-flex">
              <div class="needs-profile-functional">
                <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="chart-header">
                  <driver-header
                    :driver-label-one="functionalDrivers[0].name"
                    :driver-label-two="functionalDrivers[1].name"
                    :driver-label-three="functionalDrivers[2].name"
                    :driver-label-four="functionalDrivers[3].name"
                  ></driver-header>
                </div>
                <div id="functional_needs_chart" class="chart"></div>
              </div>
              <div class="needs-profile-emotional">
                <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="chart-header">
                  <div class="row justify-content-left no-gutters">
                    <div v-for="(emotionalDriver, idxEmotionalDrivers) in emotionalDrivers" 
                          :key="idxEmotionalDrivers" 
                          :class="'flex-column driver-header-'+(idxEmotionalDrivers+1)"
                          v-html="emotionalDriver.name"></div>
                  </div>                  
                </div>
                <div id="emotional_needs_chart" class="chart"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="functionalTable.tableContainerId" class="chart-data">
          <chart-data-table
            ref="functionalDataTable"
            v-show="this.$parent.getDisplayView() && getDisplayView()"
            :chart-data="this.functionalTable.data"
            :display-direction="'vertical'"
            :data-container-id="functionalTable.tableContainerId"
            :container-id="'functional_needs_chart'"
            :column-defs="this.chart.columnDefsFunctional"
            :table-class="'table display row-border table-hover'"
            :table-width="'auto'"
            :table-title="this.functionalTable.title"
            :report-page-type-name="'Table - Functional Needs'"
            :insight-modal-id="'functional-needs-table'"
          ></chart-data-table>
        </div>
      </div>
      <div id="cp-by-emotional-need-chart" class="emotional-needs col-lg-12">
        <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="emotionalTable.tableContainerId" class="chart-data">
          <chart-data-table
            ref="emotionalDataTable"
            :chart-data="this.emotionalTable.data"
            :data-container-id="emotionalTable.tableContainerId"
            :container-id="'emotional_needs_chart'"
            :column-defs="this.chart.columnDefsEmotional"
            :table-title="this.emotionalTable.title"
            :table-class="'table display responsive row-border table-hover'"
            :table-width="'auto'"
            :report-page-type-name="'Table - Emotional Needs'"
            :insight-modal-id="'emotional-needs-table'"
          ></chart-data-table>
        </div>
      </div>
    </div>
    <insights
      ref="insightsFunctionalChart"
      :modal-name="'functional-needs-chart'"
      :report-page-type-name="'Chart - Needs Profile'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsFunctionalTable"
      :modal-name="'functional-needs-table'"
      :report-page-type-name="'Table - Functional Needs'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsEmotionalTable"
      :modal-name="'emotional-needs-table'"
      :report-page-type-name="'Table - Emotional Needs'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ChartLegend from "../../../components/chart/ChartLegend.vue";
import ChartButtons from "../../../components/chart/ChartButtons.vue";
import DriverHeader from "../../../templates/DriverHeader.vue";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import NetPromoterScore from "../../../components/chart/NetPromoterScore.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
export default {
  name: "ByNeed",
  mixins: [ChartCompanyMixins],
  components: {  ChartLegend, ChartButtons,DriverHeader },
  data() {
    return {
      barList: {},
      emotionalChart: {},
      functionalChart: {},
      functionalTable: {
        id: "",
        tableContainerId: "functional_needs_data_container",
        data: {},
        title:
          "<h4 class='text-primary'>Functional Needs" +
          this.buildSmartCenterLink("Expectations", "Profiles") +
          "</h4><div class='chart-title functional'><div class='chart-sub-title'><span>Importance/Satisfaction Gap</span> vs. <span>Pricing Power</span></div></div>"
      },
      emotionalTable: {
        id: "",
        tableContainerId: "emotional_needs_data_container",
        data: {},
        title:
          "<h4 class='text-primary'>Emotional Needs" +
          this.buildSmartCenterLink("Emotions", "Profiles") +
          "</h4><div class='chart-title emotional'><div class='chart-sub-title'><span>Ideal/Company Gap</span> vs. <span>Pricing Power</span></div></div>"
      },
      isMobile: false,
      functionalDrivers: ChartService.getDefaultFunctionalDrivers(),
      emotionalDrivers: ChartService.getDefaultEmotionalDrivers(),
      itemsToRemove: {
        lastColumns: 2,
        firstColumns: 1,
        lastRows: 1
      }
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {},
  mounted() {
    $.extend(this.$refs.functionalDataTable.configuration, { orderFixed: [[0, "asc"]] });
    $.extend(this.$refs.emotionalDataTable.configuration, { orderFixed: [[0, "asc"]] });
    let vm = this;
    $(window).smartresize(function() {
      if (vm.$parent.isByNeed) {
        vm.smartRedrawChart($("#functional_needs_chart"));
        vm.smartRedrawChart($("#emotional_needs_chart"));
      }
    });
  },
  created() {},
  methods: {
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Needs Profile") {
        this.$refs.insightsFunctionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Functional Needs") {
        this.$refs.insightsFunctionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Emotional Needs") {
        this.$refs.insightsEmotionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsEmotionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    onChartReady(chart, google) {
      this.chartsLib = google;
      this.emotionalChart = new google.visualization.ChartWrapper({
        chartType: "LineChart",
        containerId: "emotional_needs_chart"
      });
      this.functionalChart = new google.visualization.ChartWrapper({
        chartType: "LineChart",
        containerId: "functional_needs_chart"
      });
    },
    async processChartData() {
      try {
        this.$parent.resetChartDisplayOptions();
        this.chart = ChartService.getChartAttributes("Profile");
        for (let i = 0; i < this.chartData.length; i++) {
          let needsData = JSON.parse(JSON.stringify(this.chartData[i]));
          let otherData = needsData["otherData"];
          this.$parent.legendElements = otherData["legend"];
          let needsList = otherData["needsList"];
          let companyColorList = otherData["companyColorList"];
          TableService.setCompanyColorList(companyColorList);
          ChartService.setMainClientXStyle(companyColorList[0].color, $("#chart-container"));

          let dynamicChartOptions = needsData["options"];
          let containerId = needsData["containerId"];

          let chartOptions = ChartService.getChartOptions(containerId);
          $.extend(chartOptions, dynamicChartOptions);
          if (this.$parent.showPricingPower) {
            this.itemsToRemove.lastColumns = 1;
          } else {
            this.itemsToRemove.lastColumns = 2;
          }
          chartOptions = this.setPricingPowerSeries(otherData, chartOptions, this.$parent.showPricingPower);
          $.extend(chartOptions.vAxes[1], ChartService.getPricingPowerVAxis(true));
          this.table.id = containerId;
          let chartContainerWidth = $("#chart-container").width();
          if (chartContainerWidth < ChartService.getMobileBreakpoint()) {
            this.isMobile = true;
          } else {
            this.isMobile = false;
          }
          let dataLengthMax = 100;
          if (this.$parent.$refs.chartCriteria.$data.showCompetitorExpectations == "Y") {
            this.$parent.processBarList(chartOptions, otherData["barList"]);
          }
          this.barList = otherData["barList"];
          if (containerId === "functional_needs_chart") {
            let breakPointList = otherData["breakPointList"];
            ChartService.setVerticalLineBreakPoints(breakPointList);
            dataLengthMax = this.isMobile ? 12 : 100;
            NeedsService.setFunctionalNeedsList(needsList);
            this.functionalTable.id = containerId;
            this.functionalTable.data = JSON.parse(JSON.stringify(needsData));
            this.$parent.setChartResults(needsData.companyList);
            this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
            for (let indexColumns = 0; indexColumns < needsData.cols.length; indexColumns++) {
              let label = needsData.cols[indexColumns]["label"];
              label = label.length > dataLengthMax ? label.substr(0, dataLengthMax) + "…" : label;
              needsData.cols[indexColumns]["label"] = label;
            }
            this.$parent.functionalChartOptions = JSON.parse(JSON.stringify(chartOptions));
            this.$parent.functionalChartOptions = ChartService.setHAxisFormat(this.$parent.chartDisplayOptions.functional.textDirection, this.$parent.functionalChartOptions);
            await ChartService.paintChart(
              this.$data.functionalChart,
              containerId,
              this.$parent.functionalChartOptions,
              needsData,
              this,
              this.itemsToRemove.lastColumns,
              this.itemsToRemove.firstColumns,
              this.itemsToRemove.lastRows
            );
            this.resetLegendElements();
          } else if (containerId === "emotional_needs_chart") {
            let labelIndex = 1;
            NeedsService.setEmotionalNeedsList(needsList);
            this.emotionalTable.id = containerId;
            let copyOfChartData = JSON.parse(JSON.stringify(needsData));
            for (let indexRows = 0; indexRows < needsData.rows.length; indexRows++) {
              let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
              let originalName = copyOfChartDataRow[labelIndex].v;
              let copyValue = copyOfChartDataRow[labelIndex].v.split(",");
              if (typeof copyValue != "undefined") {
                if (indexRows <= 4 ) {
                  this.setEmotionDriverName(copyValue[0], indexRows);
                }
                copyOfChartDataRow[labelIndex].v = copyValue[0];
                if (typeof copyValue[1] != "undefined") {
                  copyOfChartDataRow[labelIndex].v += " (vs. " + copyValue[1] + ")";
                  // Substitute the name in the needList
                  NeedsService.replaceNeedName(originalName, copyOfChartDataRow[labelIndex].v, "emotional");
                }
              }
            }
            this.emotionalTable.data = copyOfChartData;
            needsData = this.drawSingleEmotionalNeedsName(needsData);
            this.$parent.valueMapData.data = otherData["needsMapList"];
            this.$parent.valueMapData.title = this.$parent.survey.name + " Needs Map";
            this.$parent.emotionalChartOptions = JSON.parse(JSON.stringify(chartOptions));
            this.$parent.emotionalChartOptions = ChartService.setHAxisFormat(this.$parent.chartDisplayOptions.emotional.textDirection, this.$parent.emotionalChartOptions);
            await ChartService.paintChart(
              this.$data.emotionalChart,
              containerId,
              this.$parent.emotionalChartOptions,
              needsData,
              this,
              this.itemsToRemove.lastColumns,
              this.itemsToRemove.firstColumns,
              this.itemsToRemove.lastRows
            );
            this.resetLegendElements();
          }
        }
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
      } catch (err) {
        ErrorService.processException("CompetitiveTrends.displayChartCallback", err, "chart", this);
      }
    },
    setShowNumberOfResponses(value){
      this.$parent.chartDisplayOptions.showNumberOfResponses = value;
    },
    async setXAxisTextDirection(containerId, direction){
        if (typeof this.$parent.$refs.chartCriteria != "undefined"){
          this.$parent.$refs.chartCriteria.setTextDirection(direction);
        }      
        this.$parent.emotionalChartOptions = ChartService.setHAxisFormat(direction, this.$parent.emotionalChartOptions);
        this.$parent.chartDisplayOptions.emotional.textDirection = direction;
        this.prePaintChart(true, "emotional_needs_chart");
        this.$parent.functionalChartOptions = ChartService.setHAxisFormat(direction, this.$parent.functionalChartOptions);
        this.$parent.chartDisplayOptions.functional.textDirection = direction;
        this.prePaintChart(true, "functional_needs_chart");
    },
    async showOrHideElementsForNeedsProfile(element) {
      if (this.$parent.$refs.chartCriteria.$data.showCompetitorExpectations == "N" || !element.elementId.includes("bar")) {
        this.$parent.functionalChartOptions.series[element.seriesNumber].pointsVisible = element.visible;
        this.$parent.emotionalChartOptions.series[element.seriesNumber].pointsVisible = element.visible;
      }
      this.$parent.chartDisplayOptions.redrawAdditionalWidgets = false;
      let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
      this.$parent.showOrHideElementsForFunctionalNeeds(element, $("#" + this.functionalTable.id));
      this.$parent.showOrHideElementsForEmotionalNeeds(element, $("#" + this.emotionalTable.id));
      if (element.visible == false) {
        if (element.elementId == "thick") {
          this.$parent.functionalChartOptions.series[element.seriesNumber].type = "line";
          this.$parent.functionalChartOptions.series[element.seriesNumber].pointSize = 0;
          this.$parent.emotionalChartOptions.series[element.seriesNumber].type = "line";
          this.$parent.emotionalChartOptions.series[element.seriesNumber].pointSize = 0;
        }
      } else {
        if (element.elementId == "thick") {
          this.$parent.functionalChartOptions.series[element.seriesNumber].type = "bars";
          this.$parent.emotionalChartOptions.series[element.seriesNumber].type = "bars";
         }
      }
      await ChartService.paintChart(
        this.$data.functionalChart,
        this.functionalTable.id,
        this.$parent.functionalChartOptions,
        needsData,
        this,
        this.itemsToRemove.lastColumns,
        this.itemsToRemove.firstColumns,
        this.itemsToRemove.lastRows
      );
      let emotionalNeedsData = JSON.parse(JSON.stringify(this.chartData[1]));
      emotionalNeedsData = this.drawSingleEmotionalNeedsName(emotionalNeedsData);
      ChartService.paintChart(
        this.$data.emotionalChart,
        this.emotionalTable.id,
        this.$parent.emotionalChartOptions,
        emotionalNeedsData,
        this,
        this.itemsToRemove.lastColumns,
        this.itemsToRemove.firstColumns,
        this.itemsToRemove.lastRows
      );
    },
    async smartRedrawChart(generatedChart) {
      generatedChart.find(".blueX").remove();
      generatedChart.find(".bar").remove();
      generatedChart.find(".vertical-line").remove();
      generatedChart.find(".horizontal-line").remove();
      this.prePaintChart(true, "functional_needs_chart");
      this.prePaintChart(true, "emotional_needs_chart");
    },
    async prePaintChart(redrawWidgets, containerId) {
      this.redrawAdditionalWidgets = redrawWidgets;
      if (this.chartData.length > 0){
        if (containerId === "functional_needs_chart") {
          let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
          await ChartService.paintChart(
            this.$data.functionalChart,
            this.functionalTable.id,
            this.$parent.functionalChartOptions,
            needsData,
            this,
            this.itemsToRemove.lastColumns,
            this.itemsToRemove.firstColumns,
            this.itemsToRemove.lastRows
          );
        } else {
          let needsData = JSON.parse(JSON.stringify(this.chartData[1]));
          needsData = this.drawSingleEmotionalNeedsName(needsData);
          ChartService.paintChart(
            this.$data.emotionalChart,
            this.emotionalTable.id,
            this.$parent.emotionalChartOptions,
            needsData,
            this,
            this.itemsToRemove.lastColumns,
            this.itemsToRemove.firstColumns,
            this.itemsToRemove.lastRows
          );
        }
      }
    },
    async postPaintChart(primary_chart, containerId, options, dataTable) {
      let xAxisIndex = 0;
      let yAxisIndex = 0;
      let greenBarColumnIndex = 2;
      let blueXColumnIndex = 3;
      let breakPointIndex = ChartService.getVerticalLineBreakPoints();
      let chartContainer = $("#" + containerId);
      let chartInterface = primary_chart.getChartLayoutInterface();
      let parentContainer = chartContainer.parent();
      let chartBase = {
        width: 0,
        left: 0,
        top: 6,
        height: chartInterface.getChartAreaBoundingBox().height
      };

      let verticalLine = {
        top: chartBase.top + 1,
        height: chartBase.height - 2,
        left: chartBase.left
      };
      let blueX = {
        top: chartBase.top - 13,
        left: chartBase.left - 8
      };
      let baseGreenBar = {
        top: chartBase.top - 8,
        left: chartBase.left - 11
      };
      let horizontalLine = {
        top: chartBase.top - 31,
        left: chartBase.left - 10
      };
      let gap = (chartInterface.getXLocation(1, xAxisIndex) - chartInterface.getXLocation(0, xAxisIndex)) / 2;

      for (var rowIndex = 0; rowIndex < dataTable.getNumberOfRows(); rowIndex++) {
        for (var barIndex = 0; barIndex < this.barList.length; barIndex++) {
          let currentBar = this.barList[barIndex];
          let value = dataTable.getValue(rowIndex, currentBar.index);
          if (!isNaN(value) && value > 0) {
            if (!this.$parent.skipPaintBar(currentBar.className, containerId)) {
              let barLeft = chartInterface.getXLocation(rowIndex, xAxisIndex) + baseGreenBar.left;
              let barTop = chartInterface.getYLocation(value, yAxisIndex) + baseGreenBar.top;
              chartContainer.append(ChartService.paintBar(barTop, barLeft, currentBar.className, currentBar.backgroundColor));
            }
          }
        }
        if (
          (containerId === "functional_needs_chart" && this.$parent.chartDisplayOptions.paintBlueXFunctionalNeeds == true) ||
          (containerId === "emotional_needs_chart" && this.$parent.chartDisplayOptions.paintBlueXEmotionalNeeds == true)
        ) {
          ChartService.paintDataPoints(options, chartInterface, dataTable, chartContainer, blueXColumnIndex, yAxisIndex, blueX.left, blueX.top);
        }
      }
      if (this.$parent.chartDisplayOptions.redrawAdditionalWidgets == true) {
        ChartService.paintNeedsProfileHeader(chartInterface, containerId, parentContainer);
        let previousXPos = chartInterface.getChartAreaBoundingBox().left;    
        let driverHeaderWidth = 0;    
        // Draw Lines
        this.drawCPLine(parentContainer.parent().parent(), chartInterface);
        if (containerId === "functional_needs_chart") {
          let driverHeaderindex = 1;
          ChartService.positionChartButtons(chartInterface, parentContainer.parent().parent());
          for (let index = 0; index < dataTable.getNumberOfRows(); index++) {
            if (breakPointIndex.includes(index)) {
              let xPos = chartInterface.getXLocation(index, xAxisIndex) + verticalLine.left;
              xPos += gap;
              let className = "vertical-line";
              chartContainer.append(ChartService.paintVerticalLine(verticalLine.top, xPos, verticalLine.height, className));
              driverHeaderWidth = xPos - previousXPos;
              previousXPos = xPos;
              parentContainer.find(".driver-header-"+driverHeaderindex).css("width", driverHeaderWidth + "px");
              driverHeaderindex += 1;
            }
          }
          let finalheaderWidth = chartInterface.getChartAreaBoundingBox().width - previousXPos;
          finalheaderWidth += chartInterface.getChartAreaBoundingBox().left;
          parentContainer.find(".driver-header-"+driverHeaderindex).css("width", finalheaderWidth + "px");
        } else {
          this.drawHorizontalLine(chartInterface, yAxisIndex, horizontalLine.top, chartContainer, horizontalLine.left);
          for (let driverHeaderindex = 1; driverHeaderindex < 6; driverHeaderindex++) {
            parentContainer.find(".driver-header-"+driverHeaderindex).css("width", "35px");
          }
        }
        parentContainer.parent().parent().parent().addClass("chart-wrapper");
        if (containerId == "emotional_needs_chart") {
           this.saveReportPage("needs_profile_chart");
        }        
      }
    },
    async saveReportPage(containerId) {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let reportPageChart = $("#" + containerId);
        reportPageChart.find(".chart-header").css("display", "block");
        let reportPageChartObject = reportPageChart[ 0 ];        
        let imageReportPageChartContent = await this.createChartImage(reportPageChartObject, false, true); 
        await ReportService.saveReportPage(imageReportPageChartContent, "Chart - Needs Profile", this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.imageUrl, "png", "Chart - Needs Profile", this.$parent.clientChart, this.saveReportPageFileCallback, this);
/*        
        let imageReportPageTableContentForFunctionalNeeds = await this.createTableImage(this, this.functionalTable.tableContainerId, false, 750, 10); 
        await ReportService.saveReportPage(imageReportPageTableContentForFunctionalNeeds, "Table - Functional Needs", this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.tableImageUrl, "png", "Table - Functional Needs", this.$parent.clientChart, this.saveReportPageFileCallback, this);

        let imageReportPageTableContentForEmotionalNeeds = await this.createTableImage(this, this.emotionalTable.tableContainerId, false, 750, 10); 
        await ReportService.saveReportPage(imageReportPageTableContentForEmotionalNeeds, "Table - Emotional Needs", this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.tableImageUrl, "png", "Table - Emotional Needs", this.$parent.clientChart, this.saveReportPageFileCallback, this);        
*/      
        await ReportService.saveReportTableFile(this.$refs.functionalDataTable.getTableData(), "Table - Functional Needs", this.$parent.clientChart, this.saveReportTableFileCallback, this);
        await ReportService.saveReportTableFile(this.$refs.emotionalDataTable.getTableData(), "Table - Emotional Needs", this.$parent.clientChart, this.saveReportTableFileCallback, this);
        await ReportService.saveReportPage(this.getReportTableContent("functional_needs_chart"), "Table - Functional Needs", this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPage(this.getReportTableContent("emotional_needs_chart"), "Table - Emotional Needs", this.$parent.clientChart, this.saveReportPageCallback, this);
      }
    },
    saveAllReportPages() {
      this.saveReportPage("needs_profile_chart");
    },
    getLegendClass: function(legendClass) {
      if (this.$parent.getDisplayView() && this.getDisplayView()) {
        legendClass += " visible";
      } else {
        legendClass += " invisible";
      }
      return legendClass;
    }
  },
  watch: {
    chartData: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.functionalChart.getChart().clearChart();} catch(e){}
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.emotionalChart.getChart().clearChart();} catch(e){}
      if (this.$parent.$refs.chartCriteria.$data.displayType == "need") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
